import * as IssueArchive from '../components/IssueArchive';

export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    IssueArchive.init();
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/taxVolume.js